import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AppleDevice, Device } from '@era/locations-sdk';
import { AppleDeviceStoreSelectors, DeviceStoreActions, DeviceStoreModels, DeviceStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject, merge } from 'rxjs';
import { first, map, withLatestFrom } from 'rxjs/operators';
import { DeviceLinkSelectorComponent } from '../device-link-selector/device-link-selector.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-device-spare',
  templateUrl: './device-spare.container.html',
  styleUrls: ['./device-spare.container.scss'],
  imports: [DeviceLinkSelectorComponent, RouterLink, AsyncPipe],
})
export class DeviceSpareContainerComponent {
  public readonly selectionSubject = new ReplaySubject<DeviceStoreModels.SelectedLocation>(1);
  public readonly data$: Observable<DeviceStoreModels.SelectedLocation>;
  public readonly selection$: Observable<DeviceStoreModels.SelectedLocation>;

  constructor(
    private readonly appleDeviceStore: Store<AppleDevice>,
    private readonly deviceStore: Store<Device>,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.data$ = this.deviceStore.select(DeviceStoreSelectors.selectSelectedLocation);
    this.selection$ = merge(this.data$, this.selectionSubject);
  }

  public isAssignedDevice() {
    return this.selection$.pipe(map((selection) => selection.brandId && selection.locationId && selection.roomId));
  }

  public updateSelection(selectedLocation) {
    this.selectionSubject.next(selectedLocation);
  }

  public spare() {
    this.appleDeviceStore
      .select(AppleDeviceStoreSelectors.selectCurrentDeviceLink)
      .pipe(withLatestFrom(this.selection$), first())
      .subscribe(([link, selection]) => {
        this.deviceStore.dispatch(
          DeviceStoreActions.DeviceAssignViewActions.deviceMarkedAsSpare({
            deviceLink: link,
            brandId: selection.brandId,
            locationId: selection.locationId,
          })
        );
        void this.router.navigate(['../'], { relativeTo: this.route });
      });
  }
}
